module.exports = __webpack_public_path__ + "img/standard-id.b63ad8d5.svg";